module.exports = __webpack_public_path__ + "img/illustrator.8cd996ef.png";